// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","extraSmallMaxWidth":"767px","container":"ayxK9g_fYLQ3rUHZQHGEG","image":"_3U87G07CFrjh3Gi5cZ-pGV","button":"_30nACs2vJhevwHeyFGHBQE","entryContainer":"_3dyw7MWbOOcOlYwVCrSJRq"};


//////////////////
// WEBPACK FOOTER
// ./src/common/glossary-entry/glossary-modal/GlossaryModal.css
// module id = 479
// module chunks = 0 1 2